/**
 * @desc Delete a support document
 */

import * as defs from '../../baseClass';
import * as Hooks from '../../../hooks';

import { getUrl } from '../../../url.utils';

import * as SWR from 'swr';

import { PontCore } from '../../../pontCore';

export class Params {
  /** supportDocumentId */
  supportDocumentId;
}

export const method = 'DELETE';

export function mutate(
  params = {},
  newValue = undefined,
  shouldRevalidate = true,
) {
  return SWR.mutate(
    Hooks.getUrlKey(
      '/v1/support_document/{supportDocumentId}',
      params,
      'DELETE',
    ),
    newValue,
    shouldRevalidate,
  );
}

export function request(params = {}, option = {}) {
  const { url, body } = getUrl(
    '/v1/support_document/{supportDocumentId}',
    params,
    'DELETE',
    option,
  );
  return PontCore.fetch(url, {
    body,
    ...option,
    method: 'DELETE',
  });
}
